import { Component, OnInit } from "@angular/core";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { LoaderService } from "src/app/_core/services";
import { SettingsService } from "../../../_services/api/settings.service";
import { MetaService } from "src/app/_core/services/meta.service";
import { responseCode } from "src/app/app.data";

@Component({
  selector: "app-new-webhook",
  templateUrl: "./new-webhook.component.html",
  styleUrls: ["./new-webhook.component.scss"],
})
export class NewWebhookComponent implements OnInit {
  isFormReady = false;
  form: FormGroup;
  collectionOfRatePlanOptions = [];
  formSubmitted = false;
  companyWebhookTriggers = [];

  // dataSource = [
  //   {
  //     id: 1,
  //     status: 'fail',
  //     trigger: 'new sub',
  //     requestTime: new Date()
  //   },
  //   {
  //     id: 13,
  //     status: 'success',
  //     trigger: 'new sub',
  //     requestTime: new Date()
  //   }
  // ];

  config = {
    cols: [
      {
        name: "Status",
        key: "responseBody.status",
      },
      {
        name: "Trigger",
        key: "companyWebhookTrigger",
      },
      {
        name: "Request time",
        key: "createdAt",
        cellTemplate: "date",
      },
      {
        name: "",
        key: "action",
        cellTemplate: "actiontemplate",
      },
    ],
  };
  triggers: any[] = [];
  id: any;
  logs: any[];

  constructor(
    private loader: LoaderService,
    private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private settingsService: SettingsService,
    private _meta: MetaService
  ) {}

  ngOnInit(): void {
    this.id = this.route.snapshot.params["id"];
    this.initForm();
    this.isFormReady = true;

    if (this.id) {
      this.fillForm(this.id);
      this.getTriggerLogs(this.id);
    } else {
      this.initTriggers();
    }
  }

  getTriggerLogs(id: number): void {
    this.settingsService.getTriggerLogs(id).subscribe(
      (res) => {
        this.logs = res.data;
      },
      () => {
        this.logs = [];
      }
    );
  }

  testTrigger(trigger) {}

  fillForm(id: number): void {
    this.settingsService.getWebhookById(id).subscribe((res) => {
      // this.form.patchValue()
      res.data.customHeaders.forEach((header) => {
        this.addHeader(header);
      });
      this.initTriggers(res.data.companyWebhookTriggers);
      this.form.patchValue(res.data);
    });
  }

  initTriggers(companyWebhookTriggers?: any[]) {
    this.companyWebhookTriggers = companyWebhookTriggers;
    this.settingsService.getWebhookTriggers().subscribe((res) => {
      this.triggers = res.data;

      companyWebhookTriggers.forEach((trigger) => {
        const selectedTrigger = this.triggers.find(
          (t) => t.id === trigger.rblWebhookTrigger.id
        );
        if (selectedTrigger) {
          selectedTrigger.selected = true;
        }
      });
    });
  }

  initForm(): void {
    this.form = this.fb.group({
      url: [null, Validators.required],
      customHeaders: this.fb.array([]),
      name: [],
      description: [],
      secretToken: [null, Validators.required],
    });
  }

  onTest(): void {
    this.loader.stopPageLoader();
  }

  onSubmit(): void {
    if (this.form.valid) {
      const selectedTriggers = this.triggers
        .filter((item) => item.selected)
        .map((item) => item.id);
      const formValue = this.form.value;
      const payload = {
        ...formValue,
        triggers: selectedTriggers,
      };

      if (!this.id) {
        this.settingsService.newWebhook(payload).subscribe(
          (res) => {
            this.router.navigate(["/main/settings/advanced/api-credentials"]);
            this.formSubmitted = false;
            this._meta.showNotification(res);
          },
          (error) => {
            this._meta.showNotification(error);
          }
        );
      } else {
        this.settingsService.editWebhook(this.id, payload).subscribe(
          (res) => {
            this.router.navigate(["/main/settings/advanced/api-credentials"]);
            this.formSubmitted = false;
            this._meta.showNotification(res);
          },
          (error) => {
            this._meta.showNotification(error);
          }
        );
      }
    } else {
      this.form.markAllAsTouched();
    }
  }

  customHeaders(): FormArray {
    return this.form.get("customHeaders") as FormArray;
  }

  addHeader(data?: any) {
    this.customHeaders().push(this.newHeader(data));
  }

  newHeader(data?: any): FormGroup {
    return this.fb.group({
      name: [data?.name, Validators.required],
      value: [data?.value, Validators.required],
    });
  }

  removeHeader(empIndex: number) {
    this.customHeaders().removeAt(empIndex);
  }

  testCompanyWebhookTriggers(webhookId: any) {
    this.settingsService
      .testCompanyWebhookTrigger(this.id, webhookId)
      .subscribe((res) => {
        if (res.data?.responseBody?.status == "400") {
          this._meta.showNotificationCustomMessage(
            responseCode.errorServerCode,
            "",
            res.data?.responseBody?.message,
            null
          );
        } else {
          this._meta.showNotification(res);
        }

        this.getTriggerLogs(this.id);
      });
  }
}
